<template lang="pug">
#content
    unit(v-bind:sidebar="sidebar")
    router-view
    site-footer
</template>

<script>
    import Store from '../store/store.js'
    import unit from './sidebar/unit.vue'
    export default {
      store: Store,
      data () {
        return {
          sidebar: [
            {
              title: '应用推广',
              iconName: 'mobile',
              iconColor: '#70ad47',
              expanded: true,
              focused: false,
              links: [
                {
                  to: '/app/promotion',
                  name: '推广分析'
                },
                {
                  to: '/app/channel',
                  name: '渠道分析'
                },
                {
                  to: '/app/region',
                  name: '地域分析'
                }
              ]
            }
          ]
        }
      },
      watch: {
        '$route' (to, from) {
          this.$store.dispatch('SET_TABLE_CHECKLIST', [])
        }
      },
      components: {
        unit
      }
    }
</script>



// WEBPACK FOOTER //
// app.vue?732eda02